import Icon from './Icon';

const NPI_RE = /^\d{10}$/;

const FULL = { OVERRIDE: 'OVERRIDE', MATCH: 'MATCH' };
const PAPER = { OVERRIDE: 'OVR', MATCH: 'MATCH' };

/**
 * @param {{
 *   value: string,
 *   claimLevelNpi: string,
 *   onChange: (npi: string) => void,
 *   density?: 'default'|'paper',
 *   disabled?: boolean,
 * }} props
 */
export default function RenderingNpiCell({ value, claimLevelNpi, onChange, density = 'default', disabled = false }) {
  const labels = density === 'paper' ? PAPER : FULL;
  const present = !!value;
  const valid = !value || NPI_RE.test(value);
  const isOverride = present && value !== claimLevelNpi;
  const isMatch = present && value === claimLevelNpi;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <input
        value={value || ''}
        placeholder={!present && claimLevelNpi ? `${claimLevelNpi} (claim)` : ''}
        disabled={disabled}
        aria-invalid={!valid}
        onChange={(/** @type {any} */ e) => onChange?.(e.target.value)}
        style={{
          width: '100%',
          padding: '4px 6px',
          fontSize: density === 'paper' ? 11 : 13,
          fontFamily: 'var(--ab-font-mono)',
          color: 'var(--ab-fg)',
          background: isOverride ? 'var(--ab-pending-soft)' : 'var(--ab-bg)',
          border: !valid ? '1.5px solid var(--ab-denied)' : '1px solid var(--ab-fg)',
          borderRadius: 'var(--ab-radius-sm)',
          outline: 'none',
        }}
      />
      {(isOverride || isMatch) && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <span style={{
            display: 'inline-block', padding: '0 4px',
            fontSize: 8, fontWeight: 'var(--ab-weight-bold)',
            letterSpacing: 'var(--ab-tracking-label)',
            color: isOverride ? 'var(--ab-fg)' : 'var(--ab-fg-subtle)',
            background: isOverride ? 'var(--ab-pending-soft)' : 'transparent',
            border: `0.5px solid ${isOverride ? 'var(--ab-pending-ring)' : 'var(--ab-border-soft)'}`,
            borderRadius: 'var(--ab-radius-xs)',
          }}>
            {isOverride ? labels.OVERRIDE : labels.MATCH}
          </span>
          {isOverride && (
            <button
              type="button" aria-label="Revert to claim NPI"
              onClick={() => onChange?.('')}
              disabled={disabled}
              style={{
                background: 'transparent', border: 'none', cursor: disabled ? 'not-allowed' : 'pointer',
                color: 'var(--ab-fg-subtle)', display: 'inline-flex', padding: 0,
              }}
            >
              <Icon name="rotate-ccw" size={11} />
            </button>
          )}
        </div>
      )}
    </div>
  );
}
